import { useSelector } from 'react-redux';

const useUserValue = () => useSelector(state => {
    return { user: state.user.user, isLogin: state.user.isLogin }
});

export default useUserValue;
